import React from 'react'
import PropTypes from 'prop-types'

import { ArrowRoundedRight } from '@aok/icon-functional'

import defaultProps from '../../../utils/propTypes/defaultProps'

const StructureMenu = ({ structureList, className }) => {
  return (
    <ul className={`grid grid-cols-1 840:grid-cols-2 gap-x-24 840:gap-x-32 ${className}`}>
      {structureList.map((listElement, index) => (
        <li className="border-b-2 border-b-4d7e6e p-16" key={`structure-menu-entry-${index}`}>
          <a
            className="
              flex group justify-between 
              text-ffffff hover:text-50eb5d focus:text-50eb5d 
              align-center items-center text-20 leading:24
              hover:cursor-pointer
              rounded
              focus-visible:ring-1 focus-visible:ring-50eb5d
              focus-visible:ring-offset-4 focus-visible:ring-offset-005e3f"
            href={listElement.url}
          >
            {listElement.title}
            <ArrowRoundedRight className="w-16 h-16 fill-current text-ffffff group-hover:text-50eb5d group-focus:text-50eb5d group-hover:scale-125 transform-transition duration-350" />
          </a>
        </li>
      ))}
    </ul>
  )
}

StructureMenu.propTypes = {
  className: PropTypes.string,
  structureList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
}

StructureMenu.defaultProps = {
  className: '',
  structureList: [
    {
      title: defaultProps.TITLE,
      url: defaultProps.URL,
    },
  ],
}

export default StructureMenu
